export default "__VITE_ASSET__DvYbIETF__"